// Shared one-line AI-output disclaimer. Rendered under every
// surface that shows model-generated prose (summary card, timeline
// prose, chat replies, drafted letters, suggested actions) as a
// small muted footer. It's a legal-safeguard reminder, not a UX
// element — keep it quiet.
//
// If we ever decide to hide it conditionally (e.g. for BYOK users
// who fully trust their own provider), the gating can live here.
export default function AiDisclaimer({
  className,
}: {
  className?: string;
}) {
  return (
    <div
      className={`ai-disclaimer muted${className ? ` ${className}` : ""}`}
      aria-label="AI-assisted content disclaimer"
    >
      AI-assisted · verify all facts
    </div>
  );
}
